export default function ProtectedPage() {
  return (<h3>Protected</h3>);
}